<script>
import AreaLink from "@/components/widgets/area-link";
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'AreaSummary',
  props: {
    propertyName: {
      type: String,
      required: true
    },
    areas: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      area: {
        name: '',
        category: '',
        nickname: '',
        ceiling_height: '',
        floor_material_type: '',
        counter_top_material: '',
        counter_top_measurement: '',
        wall_material: '',
        additional_information: ''
      },
      nameOptions: ["AC CLOSET 1", "AC CLOSET 2", "AC CLOSET 3", "AC CLOSET 4", "ATTIC", "BALCONY", "BAR AREA", "BASEMENT", "BATHROOM 1", "BATHROOM 1 CLOSET", "BATHROOM 10", "BATHROOM 10 CLOSET", "BATHROOM 11", "BATHROOM 11 CLOSET", "BATHROOM 12", "BATHROOM 12 CLOSET", "BATHROOM 2", "BATHROOM 2 CLOSET", "BATHROOM 3", "BATHROOM 3 CLOSET", "BATHROOM 4", "BATHROOM 4 CLOSET", "BATHROOM 5", "BATHROOM 5 CLOSET", "BATHROOM 6", "BATHROOM 6 CLOSET", "BATHROOM 7", "BATHROOM 7 CLOSET", "BATHROOM 8", "BATHROOM 8 CLOSET", "BATHROOM 9", "BATHROOM 9 CLOSET", "BEDROOM 1", "BEDROOM 1 CLOSET 1", "BEDROOM 1 CLOSET 2", "BEDROOM 10", "BEDROOM 10 CLOSET 1", "BEDROOM 10 CLOSET 2", "BEDROOM 11", "BEDROOM 11 CLOSET 1", "BEDROOM 11 CLOSET 2", "BEDROOM 12", "BEDROOM 12 CLOSET 1", "BEDROOM 12 CLOSET 2", "BEDROOM 13", "BEDROOM 13 CLOSET 1", "BEDROOM 13 CLOSET 2", "BEDROOM 14", "BEDROOM 14 CLOSET 1", "BEDROOM 14 CLOSET 2", "BEDROOM 15", "BEDROOM 15 CLOSET 1", "BEDROOM 15 CLOSET 2", "BEDROOM 2", "BEDROOM 2 CLOSET 1", "BEDROOM 2 CLOSET 2", "BEDROOM 3", "BEDROOM 3 CLOSET 1", "BEDROOM 3 CLOSET 2", "BEDROOM 4", "BEDROOM 4 CLOSET 1", "BEDROOM 4 CLOSET 2", "BEDROOM 5", "BEDROOM 5 CLOSET 1", "BEDROOM 5 CLOSET 2", "BEDROOM 6", "BEDROOM 6 CLOSET 1", "BEDROOM 6 CLOSET 2", "BEDROOM 7", "BEDROOM 7 CLOSET 1", "BEDROOM 7 CLOSET 2", "BEDROOM 8", "BEDROOM 8 CLOSET 1", "BEDROOM 8 CLOSET 2", "BEDROOM 9", "BEDROOM 9 CLOSET 1", "BEDROOM 9 CLOSET 2", "BEDROOM HALLWAY", "CABANA", "CLOSET", "DEN", "DINETTE AREA", "DINING ROOM", "DINING ROOM 2", "EXTERIOR BACK", "EXTERIOR FRONT", "EXTERIOR LEFT SIDE OF FRONT", "EXTERIOR RIGHT SIDE OF FRONT", "FAMILY ROOM", "FLORIDA ROOM", "FOYER", "FOYER CLOSET", "GARAGE", "GYM/WORKOUT ROOM", "HALLWAY", "HALLWAY CLOSET", "HOME GYM", "HOME THEATER", "KITCHEN", "KITCHEN 2", "LAUNDRY", "LIBRARY/STUDY", "LINEN CLOSET", "LIVING ROOM", "LOFT", "MASTER BATHOOM CLOSET", "MASTER BATHROOM", "MASTER BEDROOM", "MASTER BEDROOM CLOSET 1", "MASTER BEDROOM CLOSET 2", "MASTER BEDROOM CLOSET 3", "MASTER BEDROOM CLOSET 4", "MOTHER IN LAW SUITE", "MUD ROOM", "NON BEDROOM or BATHROOM CLOSETS", "OFFICE 1", "OFFICE 2", "OTHER ROOM 1", "OTHER ROOM 10", "OTHER ROOM 11", "OTHER ROOM 12", "OTHER ROOM 2", "OTHER ROOM 3", "OTHER ROOM 4", "OTHER ROOM 5", "OTHER ROOM 6", "OTHER ROOM 7", "OTHER ROOM 8", "OTHER ROOM 9", "PANTRY", "PATIO/DECK", "PLAYROOM/REC ROOM", "PORCH", "ROOF", "SHED", "STAIRS/STAIRWAY", "STORAGE AREA UNDER STAIRWELL", "SUN ROOM", "UTILITY ROOM", "WINE CELLAR"],
      floorMaterialTypeOptions: ["TILE", "MARBLE", "STONE", "WOOD HARDWOOD", "WOOD ENGINEERED", "LAMINATE", "VINYL", "LINOLEUM", "CARPETING", "CONCRETE OR RESIN", "CORK", "BAMBOO", "OTHER"],
      counterTopMaterialOptions: ["GRANITE", "QUARTZ", "MARBLE", "STONE", "TILE CERAMIC OR PORCELAIN", "GLASS", "SOAPSTONE", "SOLID SURFACE", "LAMINATE", "WOOD", "STAINLESS STEEL", "CONCRETE", "GLASS C", "OTHER"],
      wallMaterialOptions: ["PAINTED", "WALLPAPER", "PANELING", "GLASS", "BRICK", "TILES", "MIRROR", "METAL", "VINYL", "CONCRETE", "PLASTIC", "OTHER"],
    };
  },
  computed: {
    ...mapGetters("area", ["selectedPropertyAreas"]),
    items() {
      // Copy to avoid destroying original array
      const areasCopy = [...this.areas];

      return this.splitToChunks(areasCopy, 3);
    },
    areaNameOptions() {
      const createdRooms = this.selectedPropertyAreas.map(area => area.name);
      const nameOptions = this.nameOptions.filter(name => !createdRooms.includes(name));
      return nameOptions
    }
  },
  methods: {
    ...mapActions("area", ["createArea"]),
    splitToChunks(array, parts) {
      let result = [];
      for (let i = parts; i > 0; i--) {
          result.push(array.splice(0, Math.ceil(array.length / i)));
      }
      return result;
    },
    resetAreaFormData() {
      this.area.name = '';
      this.area.category = '';
      this.area.nickname = '';
      this.area.ceiling_height = '';
      this.area.floor_material_type = '';
      this.area.counter_top_material = '';
      this.area.counter_top_measurement = '';
      this.area.wall_material = '';
      this.area.additional_information = '';
    },
    tryToCreateArea() {
      this.createArea(this.area);
    },
  },
  components: { AreaLink }
}
</script>
<template>
  <div class="area-summary widget">
    <h5><span class="summary-label">Area/Room Summary:</span><span class="property-name">{{ this.propertyName }}</span></h5>
    <div class="row summary">
      <ul class="col-md">
        <li v-for="item in items[0]" :key="item.id">
          <AreaLink :item="item" />
        </li>
      </ul>
      <ul class="col-md">
        <li v-for="item in items[1]" :key="item.id">
          <AreaLink :item="item" />
        </li>
      </ul>
      <ul class="col-md">
        <li v-for="item in items[2]" :key="item.id">
          <AreaLink :item="item" />
        </li>
      </ul>
      <div class="add-area">
        <b-button v-if="$can('create', 'Area')" class="px-2" v-b-modal.modal-createArea variant="primary" @click="resetAreaFormData()">
          Add Area
        </b-button>
      </div>
    </div>
    <b-modal id="modal-createArea" title="Create Area" @ok="tryToCreateArea()">
      <div>
        <form>
          <b-form-group
            class="mb-3"
            label="Name"
            label-for="name-input"
            label-cols-lg="4"
          >
            <b-form-select
              id="name-input"
              v-model="area.name"
              :options="areaNameOptions"
            ></b-form-select>
          </b-form-group>
          
          <b-form-group
            class="mb-3"
            label="NickName"
            label-for="nickname-input"
            label-cols-lg="4"
          >
            <b-form-input
              id="nickname-input"
              type="text"
              v-model="area.nickname"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            class="mb-3"
            label="CeilingHeight"
            label-for="ceiling_height-input"
            label-cols-lg="4"
          >
            <b-form-input
              id="ceiling_height-input"
              type="text"
              v-model="area.ceiling_height"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            class="mb-3"
            label="FloorMaterialType"
            label-for="floor_material_type-input"
            label-cols-lg="4"
          >
            <b-form-select
              id="floor_material_type-input"
              v-model="area.floor_material_type"
              :options="floorMaterialTypeOptions"
            ></b-form-select>
          </b-form-group>

          <b-form-group
            class="mb-3"
            label="CounterTopMaterial"
            label-for="counter_top_material-input"
            label-cols-lg="4"
          >
            <b-form-select
              id="counter_top_material-input"
              v-model="area.counter_top_material"
              :options="counterTopMaterialOptions"
            ></b-form-select>
          </b-form-group>

          <b-form-group
            class="mb-3"
            label="CounterTopMeasurement"
            label-for="counter_top_measurement-input"
            label-cols-lg="4"
          >
            <b-form-input
              id="counter_top_measurement-input"
              type="text"
              v-model="area.counter_top_measurement"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            class="mb-3"
            label="WallMaterial"
            label-for="wall_material-input"
            label-cols-lg="4"
          >
            <b-form-select
              id="wall_material-input"
              v-model="area.wall_material"
              :options="wallMaterialOptions"
            ></b-form-select>
          </b-form-group>

          <b-form-group
            class="mb-3"
            label="AdditionalInformation"
            label-for="additional_information-input"
            label-cols-lg="4"
          >
            <b-form-input
              id="additional_information-input"
              type="text"
              v-model="area.additional_information"
            ></b-form-input>
          </b-form-group>
          <!---<b-form-group
            class="mb-3"
            label="Category"
            label-for="category-input"
            label-cols-lg="4"
          >
            <b-form-input
              id="category-input"
              type="text"
              v-model="area.category"
            ></b-form-input>
          </b-form-group>--->
        </form>
      </div>
    </b-modal>
  </div>
</template>
